import { translate } from '@jsverse/transloco';
export enum CorrelationType {
    ASSET = 'ASSET',
    EVENT = 'EVENT',
}

export class CorrelationTypeHelper {
    static getCorrelationTypeLocale(type: CorrelationType) {
        switch (type) {
            case CorrelationType.ASSET:
                return translate('CORE.CORRELATION_TYPE.ASSET');
            case CorrelationType.EVENT:
                return translate('CORE.CORRELATION_TYPE.EVENT');

            default:
                return type;
        }
    }
}
